import type {GettextInterface} from "@indeed/indeed-gettext";

import {Box, Text} from "../../../../../../../../mads";
import { HtmlContent } from '../../../../../../../../shared/components/HtmlContent';
import ViewJobLabelledContent from '../../common/ViewJobLabelledContent/ViewJobLabelledContent';

import React from 'react';
import {StyleSheet} from "react-native";


interface IntroSectionProps {
    isRemote: boolean;
    useVip: boolean;
    introHeader: string;
    introContent: string;
    gt: GettextInterface;
}

export const IntroSection: React.FC<IntroSectionProps> = ({
    introHeader,
    introContent,
    isRemote,
    useVip,
    gt,
}) => {
    if (!introHeader.length || !introContent.length) {
        let header;
        let content;
        if (useVip) {
            header = gt.pgettext(
                'View job details - introduction section - virtual interview header ',
                'What is a virtual interview?',
            );
            content = gt.pgettext(
                'View job details - introduction section - description of virtual interview',
                'Virtual interviews help employers connect with job seekers when they are not in the same physical location. Since hiring is a human process, employers would like to talk with you online (chat, video or phone) to see if you meet the requirements for the job.',
            );
        } else if (isRemote) {
            header = gt.pgettext(
                'View job details - introduction section - virtual hiring event header',
                'What is a virtual hiring event?',
            );
            content = gt.pgettext(
                'View job details - introduction section - description of virtual hiring event',
                "Virtual hiring events are a great way for employers and jobseekers to connect, even if they aren't in the same physical location. Hiring is a human process, and they would like to talk with you online (either through chat, on the phone, or video) to see if you’re a fit!",
            );
        } else {
            header = gt.pgettext(
                'View job details - introduction section - hiring event header',
                'What is a hiring event?',
            );
            content = gt.pgettext(
                'View job details - introduction section - description of hiring event',
                'Think of it like a job fair, but for one company and more personal. Hiring events are a great way for employers to fill multiple roles quickly. Hiring is a human process, and they would like to meet you to see if you’re a fit!',
            );
        }

        return <ViewJobLabelledContent label={header}><Text level={3}>{content}</Text></ViewJobLabelledContent>;
    }

    return (
        <Box sx={styles.introSectionHtmlContainer}>
            <HtmlContent>{introHeader}</HtmlContent>
            <HtmlContent>{introContent}</HtmlContent>
        </Box>
    );
};

const styles = StyleSheet.create({
    introSectionHtmlContainer: {
        marginTop: 16,
    },
});
